import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, NavigationExtras } from "@angular/router";
import { AppComponent } from '../app.component';
import { AuthenticationService } from '../_services/authentication.service';
// import { FormControl, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  
  loginForm: FormGroup;
  error = false;
  userData: any;
  msg: string;
  selectedService: any;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private appComp: AppComponent,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {

  //   this.form = new FormGroup({
  //     'title': new FormControl(null)
  // });

  this.loginForm = this.formBuilder.group({
    prod_user_name: ["", Validators.required],
    prod_password: ["", Validators.required]
  });

  }

  signIn(){
    this.error = false;
    // this.appComp.loading = true;
    let rawValue = this.loginForm.getRawValue();
    this.authService.authenticationState.next(true);
    
    // if (this.loginForm.invalid) {
      //   this.error = true;
      //   this.msg = "Faltan campos por llenar.";
      //   this.appComp.loading = false;
      //   return;
      // }
      // this.selectedService = 'insurance';
      this.authService.signIn(rawValue).then((res:any)=>{
      console.log('LOGIN AUTH VALUES RESPONSE',res);
      if(!res){
        this.error = true;
        this.appComp.loading = false;
        this.msg = "Credenciales incorrectos. Intente nuevamente.";
        return
      }else{
        if(res.Active == "False"){
          this.msg = "Su cuenta esta inactiva.";
          return;
        }
        if(res.ChallengeName){
          if(res.ChallengeName.Value == "NEW_PASSWORD_REQUIRED"){
            this.userData = res;
          }
        }else{
          this.appComp.loading = false;
          this.authService.authenticationState.next(true);
        }
        localStorage.setItem('suc_agency', res.suc_agency)
        this.error = false;
        this.appComp.loading = false;
        this.router.navigate(['/dashboard']);
      }
      this.appComp.loading = false;
    }, (err: any)=>{
      if(typeof err == 'string'){
        this.msg = err;
      }else{  
        this.msg = err.errorMessage;
      }
      
      this.error = true;
      this.appComp.loading = false;
    })
  }

  // goToQuotation() {
  //   if(this.loginForm.controls['CodigoOperador'].value == "0000" && this.loginForm.controls['Password'].value == "1234"){
  //     this.router.navigateByUrl('/quotation');
  //     this.authService.authenticationState.next(true);
  //     this.appComp.user.role = "productor";
  //     this.error = false;
  //   }else{
  //     this.error = true;
  //   }
    
  // }

}
